import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Play, SkipForward, SkipBack } from "lucide-react";

export default function PlaylistPlayer() {
  const { pid } = useParams();
  const [p, setP] = useState(null);
  const [idx, setIdx] = useState(0);
  const videoRef = useRef(null);

  useEffect(() => { api.get(`/playlists/${pid}`).then(r=>setP(r.data)); }, [pid]);
  if (!p) return <div className="p-8 text-white/60">Loading…</div>;
  if (p.videos.length === 0) return <div className="p-8 text-white/60">Playlist is empty.</div>;

  const cur = p.videos[idx];
  const next = () => setIdx(i => (i + 1) % p.videos.length);
  const prev = () => setIdx(i => (i - 1 + p.videos.length) % p.videos.length);

  return (
    <div className="mx-auto max-w-6xl px-3 sm:px-6 pt-4">
      <h1 className="h-font text-2xl font-bold">{p.name}</h1>
      <p className="text-white/60 text-sm">by @{p.username} · {p.videos.length} videos</p>
      <div className="mt-4 grid lg:grid-cols-[1fr_320px] gap-4">
        <div>
          <div className="aspect-video rounded-xl overflow-hidden bg-black">
            <video ref={videoRef} src={cur.video_url || undefined} poster={cur.thumbnail_url || undefined} controls autoPlay className="w-full h-full"
                   onEnded={next} data-testid="playlist-video"/>
          </div>
          <div className="flex items-center gap-2 mt-3">
            <button onClick={prev} data-testid="playlist-prev" className="jx-btn h-10 px-4 rounded-full bg-white/5 hover:bg-white/10 inline-flex items-center gap-2"><SkipBack size={14}/> Prev</button>
            <button onClick={next} data-testid="playlist-next" className="jx-btn h-10 px-4 rounded-full bg-[#08D9D6] text-black font-bold inline-flex items-center gap-2">Next <SkipForward size={14}/></button>
          </div>
          <h2 className="h-font text-xl font-bold mt-4">{cur.title}</h2>
          <p className="text-white/60 text-sm">@{cur.creator?.username}</p>
        </div>
        <div className="rounded-2xl border border-white/10 bg-white/5 p-2 max-h-[70vh] overflow-y-auto">
          {p.videos.map((v, i) => (
            <button key={v.id} onClick={()=>setIdx(i)} className={`w-full text-left flex gap-3 items-center p-2 rounded-lg jx-btn ${i===idx?'bg-[#08D9D6]/20':'hover:bg-white/5'}`}>
              <div className="relative w-24 aspect-video rounded overflow-hidden shrink-0">
                <img src={v.thumbnail_url || undefined} alt="" className="w-full h-full object-cover"/>
                {i===idx && <div className="absolute inset-0 bg-black/50 flex items-center justify-center"><Play size={16} className="text-[#08D9D6] fill-[#08D9D6]"/></div>}
              </div>
              <div className="min-w-0"><div className="text-sm font-semibold line-clamp-2">{v.title}</div><div className="text-xs text-white/50">@{v.creator?.username}</div></div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
